import { VehicleLicenseDetailsOutput } from './vehicle-license-details-output.model';


export class VehicleLicenseDetailsSelectByIdOutput implements IVehicleLicenseDetailsSelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleLicenseDetailsOutput;

    constructor(data?: IVehicleLicenseDetailsSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleLicenseDetailsOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleLicenseDetailsSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLicenseDetailsSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleLicenseDetailsSelectByIdOutput {
    status: number;
    message: string;
    data: VehicleLicenseDetailsOutput;
}

